import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

import './AlertWithIcon.scss';

/**
 * Displays a React Bootstrap Alert component with an added custom icon to the left.
 */
function AlertWithIcon({
  icon, alt,
  variant = 'primary',
  iconBackground = 'bg-white',
  children,
}) {
  return (
    <Alert variant={variant}>
      <div className="d-flex align-items-center">
        <div className={`icon-container ${iconBackground}`}>
          <img
            src={icon}
            alt={alt}
          />
        </div>
        <div className="ms-3">
          {children}
        </div>
      </div>
    </Alert>
  );
}

AlertWithIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  iconBackground: PropTypes.string,
  alt: PropTypes.string.isRequired,
  variant: PropTypes.string,
  children: PropTypes.node.isRequired,
};

AlertWithIcon.defaultProps = {
  variant: 'primary',
  iconBackground: 'bg-white',
};

export default AlertWithIcon;
